import { render, staticRenderFns } from "./ButtonContactComponent.vue?vue&type=template&id=c82b78f6&scoped=true"
import script from "./ButtonContactComponent.vue?vue&type=script&lang=js"
export * from "./ButtonContactComponent.vue?vue&type=script&lang=js"
import style0 from "./ButtonContactComponent.vue?vue&type=style&index=0&id=c82b78f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82b78f6",
  null
  
)

export default component.exports